import { AiOutlineExclamationCircle } from 'react-icons/ai';
import {
  IJobListFilters,
  IJobShiftsCounters,
  JobShiftsQuickFilters,
} from '@th-types/jobs.type';
import { jobShiftsFilterMap } from '@utils/JobUtils';
import { Badge, Stack } from 'react-bootstrap';
import TooltipOverlay from '@components/elements/Tooltip';
import './style.scss';

interface Props {
  jobListFilters: IJobListFilters;
  jobShiftsCounters?: IJobShiftsCounters;
  executeJobShiftsViewBadgeAction: (quickFilter: JobShiftsQuickFilters) => void;
}

export default function JobShiftsViewQuickFilters({
  jobListFilters,
  jobShiftsCounters,
  executeJobShiftsViewBadgeAction,
}: Props) {
  const quickFilters = [
    JobShiftsQuickFilters.CURRENT_OPEN_SHIFTS,
    JobShiftsQuickFilters.ONBOARDING,
    JobShiftsQuickFilters.NO_CHECK_IN_OUT,
    JobShiftsQuickFilters.MISSING_HOURS,
    JobShiftsQuickFilters.TO_APPROVE,
    JobShiftsQuickFilters.MARK_PAID,
  ];

  const getJobShiftsFilterBadgeText = (
    quickFilterName: JobShiftsQuickFilters
  ) => {
    const counterMap = {
      [JobShiftsQuickFilters.CURRENT_OPEN_SHIFTS]:
        jobShiftsCounters?.countOpenShifts,
      [JobShiftsQuickFilters.ONBOARDING]: jobShiftsCounters?.countOnboarding,
      [JobShiftsQuickFilters.NO_CHECK_IN_OUT]:
        jobShiftsCounters?.countNoCheckInOut,
      [JobShiftsQuickFilters.MARK_PAID]: jobShiftsCounters?.countMarkPaid,
      [JobShiftsQuickFilters.MISSING_HOURS]:
        jobShiftsCounters?.countMissingHours,
      [JobShiftsQuickFilters.TO_APPROVE]: jobShiftsCounters?.countToApprove,
    } as Record<JobShiftsQuickFilters, number | undefined>;

    const count = counterMap[quickFilterName];
    return `${quickFilterName} (${count || '0'})`;
  };

  const getBadgeColor = (quickFilterName: JobShiftsQuickFilters) => {
    const filterKey = jobShiftsFilterMap[quickFilterName];
    if (jobListFilters[filterKey]) {
      return `quick-filter-badge__${quickFilterName.toLowerCase().replace(/[\s/-]/g, '_')}`;
    }
    return '';
  };

  return (
    <Stack direction="horizontal">
      <TooltipOverlay
        text="Quick Filter counts are automatically removed 30 days after a shift"
        position="bottom"
      >
        <AiOutlineExclamationCircle
          className="me-1 mb-1"
          color="var(--black)"
        />
      </TooltipOverlay>
      {quickFilters.map((quickFilterName) => {
        return (
          <Badge
            className={`me-2 badge-header ${getBadgeColor(quickFilterName)}`}
            pill
            bg="light"
            text="dark"
            key={quickFilterName}
            onClick={() => {
              executeJobShiftsViewBadgeAction(quickFilterName);
            }}
          >
            {getJobShiftsFilterBadgeText(quickFilterName)}
          </Badge>
        );
      })}
    </Stack>
  );
}
